import { createReducer } from 'typesafe-actions';

import {
  IKycNeedReviewState,
  TKycNeedReviewAction,
  KycActionTypes,
} from '@/features/kyc/store/types/kyc-need-review.types';

const initialState: IKycNeedReviewState = {
  isLoading: false,
};

export const kycNeedReviewReducer = createReducer<IKycNeedReviewState, TKycNeedReviewAction>(initialState)
  .handleType(KycActionTypes.GET_KYC_NEED_REVIEW_DOCUMENTS, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))

  .handleType(KycActionTypes.GET_KYC_NEED_REVIEW_DOCUMENTS_SUCCESS, (state, action) => {
    return {
      ...state,
      documents: {
        ...action.needReviewDocuments,
        elements: action.needReviewDocuments?.elements?.map((document) => ({
          state: { document },
        })),
      },
      isLoading: false,
      error: undefined,
    };
  })

  .handleType(KycActionTypes.GET_KYC_NEED_REVIEW_DOCUMENTS_FAIL, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  }))

  .handleType(KycActionTypes.GET_KYC_NEED_REVIEW_DOCUMENT_PREVIEW, (state, action) => ({
    ...state,
    documents: {
      ...state.documents,
      elements:
        state.documents?.elements.map((needReviewDocument) => {
          if (needReviewDocument.state?.document.documentId === action.documentId)
            return {
              ...needReviewDocument,
              isLoading: true,
              error: undefined,
            };

          return needReviewDocument;
        }) || [],
    },
    isLoading: false,
    error: undefined,
  }))

  .handleType(KycActionTypes.GET_KYC_NEED_REVIEW_DOCUMENT_PREVIEW_SUCCESS, (state, action) => {
    return {
      ...state,
      documents: {
        ...state.documents,
        elements:
          state.documents.elements?.map((needReviewDocument) => {
            if (needReviewDocument.state?.document.documentId === action.documentId)
              return {
                ...needReviewDocument,
                state: {
                  ...needReviewDocument.state,
                  preview: action.preview,
                },
                isLoading: false,
                error: undefined,
              };

            return needReviewDocument;
          }) || [],
      },
      isLoading: false,
      error: undefined,
    };
  })

  .handleType(KycActionTypes.GET_KYC_NEED_REVIEW_DOCUMENT_PREVIEW_FAIL, (state, action) => ({
    ...state,
    documents: {
      ...state.documents,
      elements:
        state.documents.elements?.map((needReviewDocument) => {
          if (needReviewDocument.state?.document?.documentId === action.documentId)
            return {
              ...needReviewDocument,
              isLoading: false,
              error: action.error,
            };

          return needReviewDocument;
        }) || [],
    },
    isLoading: false,
    error: undefined,
  }))

  .handleType(KycActionTypes.REVIEW_NEED_REVIEW_DOCUMENT, (state, action) => ({
    ...state,
    documents: {
      ...state.documents,
      elements:
        state.documents?.elements.map((needReviewDocument) => {
          if (needReviewDocument.state?.document?.documentId === action.document.documentId)
            return {
              ...needReviewDocument,
              state: {
                ...needReviewDocument.state,
                edit: {
                  isLoading: true,
                  error: undefined,
                },
              },
              isLoading: false,
              error: undefined,
            };

          return needReviewDocument;
        }) || [],
    },
    isLoading: false,
    error: undefined,
  }))
  .handleType(KycActionTypes.REVIEW_NEED_REVIEW_DOCUMENT_FAIL, (state, action) => ({
    ...state,
    documents: {
      ...state.documents,
      elements:
        state.documents?.elements.map((needReviewDocument) => {
          if (needReviewDocument.state?.document?.documentId === action.document.documentId)
            return {
              ...needReviewDocument,
              state: {
                ...needReviewDocument.state,
                edit: {
                  isLoading: false,
                  error: action.error,
                },
              },
            };

          return needReviewDocument;
        }) || [],
    },
  }))

  .handleType(KycActionTypes.REVIEW_NEED_REVIEW_DOCUMENT_SUCCESS, (state, action) => ({
    ...state,
    documents: {
      ...state.documents,
      elements:
        state.documents?.elements.map((needReviewDocument) => {
          if (needReviewDocument.state?.document?.documentId === action.document.documentId)
            return {
              state: {
                ...needReviewDocument.state,
                document: action.document,
                edit: {
                  isLoading: false,
                  error: undefined,
                },
              },
            };

          return needReviewDocument;
        }) || [],
    },
  }));
